import React, { Component } from 'react';
import $ from '../../common/AjaxRequest';
import { Form, Modal, message, InputNumber } from 'antd';
import API_URL from '../../common/url';

const FormItem = Form.Item;

class CreateForm extends Component {
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
                md: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 12 },
            },
        };
        const mainCode = getFieldValue('mainCode') || "";
        const investigationName = getFieldValue('investigationName') || "";
        return (
            <div className="create-form">
                <Form>
                    <FormItem
                        {...formItemLayout}
                        label="JDE主项目号"
                    >
                        {mainCode}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="项目简称"
                    >
                        {investigationName}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="超限阀值">
                        {
                            getFieldDecorator('thresholdValue', {
                                rules: [
                                    { required: true, message: '请输入超限阀值' }
                                ],
                            })(
                                <InputNumber
                                    style={{ width: 140 }}
                                    min={0}
                                    precision={2}
                                />
                            )
                        }
                        <span>%</span>
                    </FormItem>
                </Form>
            </div>
        );
    }
}

class TransfiniteModal extends Component {
    state = {
        visible: false,
        confirmLoading: false,
        id: 0,
    }

    show = id => {
        this.setState({
            visible: true,
        });
        if (id) {
            this.loadData(id);
            this.setState({ id });
        }
    };

    hide = () => {
        this.setState({
            visible: false,
        });
    };

    /**
     * 获取项目详细信息
     * @param id
     */
    loadData = id => {
        const options = {
            method: 'POST',
            url: API_URL.sumtotal.queryInvestigationById,
            data: {
                investigationId: id
            },
            dataType: 'json',
            doneResult: (res) => {
                this.setState({
                    AcInfo: res && res.data,
                });
            },
        };
        $.sendRequest(options);
    }

    // 提交表单
    handleSubmit = () => {
        this.refs.form.validateFieldsAndScroll((errors, values) => {
            if (errors) {
                return;
            }
            this.setState({ confirmLoading: true });
            const fieldsValue = this.refs.form.getFieldsValue();
            const { thresholdValue } = fieldsValue || 110;
            const { id } = this.state;
            const { curRole } = sessionStorage;
            const url = (curRole !== 'PM' && curRole !== 'PML') ? API_URL.sumtotal.setInvestigationFinishThreshold : API_URL.sumtotal.sendtInvestigationFinishThresholdApply;
            const options = {
                method: 'POST',
                url,
                data: {
                    investigationId: id,
                    value: thresholdValue && thresholdValue.toFixed(2)
                },
                dataType: 'json',
                doneResult: data => {
                    message.success(data.success);
                    this.setState({ confirmLoading: false }, () => {
                        this.hide();
                        this.props.loadData();
                    });
                },
                errorResult: () => {
                    this.setState({ confirmLoading: false });
                }
            };
            $.sendRequest(options);
        });
    }

    render() {
        const { curRole } = sessionStorage;
        const { confirmLoading, visible, AcInfo } = this.state;
        const mapPropsToFields = () => ({
            mainCode: { value: AcInfo && AcInfo.mainCode },
            investigationName: { value: AcInfo && AcInfo.investigationName },
            thresholdValue: { value: (AcInfo && AcInfo.thresholdValue) || 110 },
        });

        CreateForm = Form.create({ mapPropsToFields })(CreateForm);
        return (
            <Modal
                title={(curRole !== 'PM' && curRole !== 'PML') ? "设置超限阀值" : "发送超限申请" }
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="570px"
                confirmLoading={confirmLoading}
            >
                <CreateForm ref="form" />
            </Modal>

        );
    }
}

export default TransfiniteModal;


// WEBPACK FOOTER //
// ./src/components/sumTotal/TransfiniteModal.js